import { FormItemsGroup as FormItemsGroupComponent, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DeductionComponentWrapper = styled.div`
  padding-top: ${Spacing.S8};
  padding-bottom: ${Spacing.S4};
`
export const FormItemsGroup = styled(FormItemsGroupComponent)`
  align-items: center;
  text-align: center;
`
